import { IGoal } from "motw_core/Entity/IGoal";

export const CanSaveProperty = (targetProperty: keyof IGoal) => {
	const canSave = targetProperty !== `isarchived`;
	return canSave;
};
